"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class CertificateServiceLive {
    getTransactionNumberWithoutCertificate(companyId, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/certificate/transactions-without-certificate/${type}`);
            return response.data;
        });
    }
    updateCertificateIssueStatus(companyId, type, status, config) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/certificate/update-certificate-status/${type}/${status}`, { type, config });
            return response.data;
        });
    }
    updateCertificateConfig(companyId, config, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/certificate/update-config`, {
                type,
                config,
            });
            return response.data;
        });
    }
    issueBulkCertificates(companyId, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/certificate/issue-certificate-bulk/${type}`);
            return response.data;
        });
    }
    generateCertificate(companyId, type, shareholderId, certificateId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/certificate/${certificateId}/shareholder/${shareholderId}/generate/${type}`);
            return response.data;
        });
    }
    getBulkCertificate(companyId, range) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/certificate/bulk-download?min=${range.min}&max=${range.max}`);
            return response.data;
        });
    }
    uploadCertificate(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("id", data.id);
            formData.append("type", data.type);
            formData.append("file", data.file, data.file.name);
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/certificate/upload`, formData);
            return response.data;
        });
    }
    getSignedInvestorCertificateUrl(companyId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/certificate/signed-url/${shareholderId}`);
            return response.data;
        });
    }
}
exports.CertificateServiceLive = CertificateServiceLive;
//# sourceMappingURL=CertificateServiceLive.js.map